var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSitcom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Smiley-Lol-Sideways--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Smiley Lol Sideways Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.5a4 4 0 0 0 -4 -4 6 6 0 0 0 -2.46 0.74 0.24 0.24 0 0 1 -0.22 0A12 12 0 0 0 1.5 17.82a0.24 0.24 0 0 1 0 0.22A5.18 5.18 0 0 0 1 20a4 4 0 0 0 6.39 3.2 0.26 0.26 0 0 1 0.24 0A12 12 0 0 0 23.05 7.3a0.25 0.25 0 0 1 0 -0.26A4 4 0 0 0 24 4.5Zm-4 -2a2 2 0 0 1 0 4c-0.88 0 -2.91 -1.28 -3.69 -1.79a0.26 0.26 0 0 1 -0.11 -0.21 0.24 0.24 0 0 1 0.11 -0.21c0.78 -0.51 2.81 -1.79 3.69 -1.79Zm-2.95 14.55a6.15 6.15 0 0 1 -5.94 1.59 0.16 0.16 0 0 1 -0.11 -0.1 0.2 0.2 0 0 1 0 -0.15L18.39 11a0.14 0.14 0 0 1 0.15 0 0.18 0.18 0 0 1 0.11 0.1 6.19 6.19 0 0 1 -1.6 5.95Zm-1.62 -9.87L12.6 9.3a1 1 0 0 1 -1 0.09 1 1 0 0 1 -0.6 -0.89V4.25a1 1 0 0 1 2 0V6a0.24 0.24 0 0 0 0.14 0.22 0.27 0.27 0 0 0 0.26 0l0.83 -0.62a1 1 0 0 1 1.4 0.2 1 1 0 0 1 -0.2 1.38Zm-9.51 6.74 0.35 -0.5a0.23 0.23 0 0 0 0 -0.26 0.24 0.24 0 0 0 -0.2 -0.16H4.26a1 1 0 0 1 0 -2H8.5a1 1 0 0 1 0.81 1.58l-1.76 2.5a1 1 0 0 1 -0.82 0.42 1 1 0 0 1 -0.58 -0.19 1 1 0 0 1 -0.23 -1.39ZM5 22a2 2 0 0 1 -2 -2c0 -0.89 1.28 -2.91 1.79 -3.69a0.26 0.26 0 0 1 0.42 0C5.72 17.09 7 19.11 7 20a2 2 0 0 1 -2 2Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSitcom);
export default ForwardRef;